import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

// Mirrors TicketHeader's layout (TicketHeaderInfo title/subtitle on the start
// side, TicketHeaderActions buttons on the end) for the brief window before the
// ticket is fetched.
const TicketHeaderSkeleton = () => (
    <div className="animate-fade flex grow items-center justify-between gap-x-3 text-gray-200">
        <div className="flex min-w-0 flex-col gap-2">
            <Skeleton.Text className="h-4 w-44" />
            <Skeleton.Text className="h-3 w-28" />
        </div>
        <div className="flex shrink-0 items-center gap-x-2">
            <div className="size-10 rounded-lg bg-current" />
            <div className="h-10 w-24 rounded-lg bg-current" />
            <div className="h-10 w-28 rounded-lg bg-current" />
        </div>
    </div>
);

export default TicketHeaderSkeleton;
